// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-panel {
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
}
.alert-panel .panel-icon {
  margin-right: 15px;
  font-size: 24px;
}
.alert-panel .panel-icon--info {
  font-size: 15px;
  margin-right: 0;
  color: var(--app-mid-light) !important;
}
.alert-panel .panel-infos {
  flex: 1;
  word-break: break-all;
  word-break: break-word;
}
.alert-panel .panel-infos .pi-row--lbl {
  font-weight: 500;
}
.alert-panel .panel-infos .pi-row--desc {
  color: var(--app-mid-light);
  font-size: 12px;
}
.alert-panel .panel-infos .pi-row--action {
  cursor: pointer;
  font-size: 12px;
}
.alert-panel .panel-infos .pi-row:not(:last-child) {
  margin-bottom: 5px;
}
.alert-panel--success {
  border-color: var(--app-succ);
}
.alert-panel--success .panel-icon {
  color: var(--app-succ);
}
.alert-panel--success .pi-row--lbl {
  color: var(--app-succ);
}
.alert-panel--warn {
  border-color: var(--app-warn);
}
.alert-panel--warn .panel-icon {
  color: var(--app-warn);
}
.alert-panel--warn .pi-row--lbl {
  color: var(--app-warn);
}
.alert-panel--error {
  border-color: var(--app-danger);
}
.alert-panel--error .panel-icon {
  color: var(--app-danger);
}
.alert-panel--error .pi-row--lbl {
  color: var(--app-danger);
}
.alert-panel--loading {
  border-color: var(--app-mid-light);
}
.alert-panel--loading .panel-icon {
  color: var(--app-mid-light);
}
.alert-panel--loading .pi-row--lbl {
  color: var(--app-mid-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/diagnostic-panel/diagnostic-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,cAAA;EAGA,eAAA;AAHF;AAME;EACE,kBAAA;EACA,eAAA;AAJJ;AAOI;EACE,eAAA;EACA,eAAA;EACA,sCAAA;AALN;AAWE;EACE,OAAA;EACA,qBAAA;EAEA,sBAAA;AAVJ;AAaM;EACE,gBAAA;AAXR;AAaM;EACE,2BAAA;EACA,eAAA;AAXR;AAeM;EACE,eAAA;EACA,eAAA;AAbR;AAiBM;EACE,kBAAA;AAfR;AAqBE;EAEE,6BADQ;AAnBZ;AAsBI;EACE,sBAJM;AAhBZ;AAwBM;EACE,sBATI;AAbZ;AA4BE;EAEE,6BADQ;AA1BZ;AA6BI;EACE,sBAJM;AAvBZ;AA+BM;EACE,sBATI;AApBZ;AAmCE;EAEE,+BADQ;AAjCZ;AAoCI;EACE,wBAJM;AA9BZ;AAsCM;EACE,wBATI;AA3BZ;AA0CE;EAEE,kCADQ;AAxCZ;AA2CI;EACE,2BAJM;AArCZ;AA6CM;EACE,2BATI;AAlCZ","sourcesContent":[".alert-panel {\n  border-radius: 5px;\n  border-width: 1px;\n  border-style: solid;\n\n  padding: 7px 10px;\n\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n\n  // Aggiunta Vigo\n  cursor: pointer;\n  // Fine aggiunta vigo\n\n  .panel-icon {\n    margin-right: 15px;\n    font-size: 24px;\n\n    // Aggiunta Vigo\n    &--info{\n      font-size: 15px;\n      margin-right: 0;\n      color: var(--app-mid-light)!important;\n    }\n    // Fine aggiunta vigo\n\n  }\n\n  .panel-infos {\n    flex: 1;\n    word-break: break-all;\n    // Edge 79, Firefox 67 - also: deprecated?\n    word-break: break-word;\n\n    .pi-row {\n      &--lbl {\n        font-weight: 500;\n      }\n      &--desc {\n        color: var(--app-mid-light);\n        font-size: 12px;\n      }\n\n      // Aggiunta da Vigo\n      &--action{\n        cursor: pointer;\n        font-size: 12px;\n      }\n      // Fine aggiunta Vigo\n\n      &:not(:last-child) {\n        margin-bottom: 5px;\n      }\n    }\n\n  }\n\n  &--success {\n    $color: var(--app-succ);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--warn {\n    $color: var(--app-warn);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--error {\n    $color: var(--app-danger);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--loading {\n    $color: var(--app-mid-light);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
